import Vue from 'vue'
const App = () => import(/* webpackPrefetch: true */ './App.vue')
import router from './router'
import store from './store'
import { config } from './config.js';
import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import filters from './filters.js';
import Multiselect from 'vue-multiselect';
import VueGoogleCharts from 'vue-google-charts';
import LoaderComponent from '@/components/preloader/LoaderComponent';
import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
import FormInput from "@/components/common/FormInput";
import Button from "@/components/common/Button";
import vmodal from 'vue-js-modal';
import "./vee-validate";
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueCarousel from 'vue-carousel';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import VueFormulate from '@braid/vue-formulate';
import { es } from '@braid/vue-formulate-i18n';
import panZoom from 'vue-panzoom';
import VueGtm from "vue-gtm";
import VueCookies from 'vue-cookies';
import 'leaflet/dist/leaflet.css';
import i18n from "./i18n";
import VueFab from 'vue-float-action-button';
import VueLazyload from 'vue-lazyload'
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueScrollTo  from'vue-scrollto';
import VueHead from 'vue-head';
import VueEcho from 'vue-echo-laravel';
import Pusher from 'pusher-js';
import VCalendar from 'v-calendar';
import * as Sentry from "@sentry/vue";
import CKEditor from '@ckeditor/ckeditor5-vue2';

Vue.use( CKEditor );
  
Vue.use(VueEcho, {
    broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_KEY,
    wsHost: 'socket.compralaentrada.com',
    wsPort: '443',
    wssPort:'443',
    forceTLS: false,
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    cluster: ''
});

Vue.use(VueYouTubeEmbed)
Vue.use(VueLazyload)
Vue.use(VueFab);
Vue.use(panZoom);
Vue.use(PerfectScrollbar);
Vue.use(VueCarousel);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueScrollTo, {
    offset: -100,
})
Vue.component('datetime', Datetime);
for(let name in filters) {
    Vue.filter(name, filters[name]);
}
Vue.use(VueToast);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.use(VueGoogleCharts);
Vue.component('multiselect', Multiselect);
Vue.component('LoaderComponent', LoaderComponent);
Vue.component('ContentOrLoading', ContentOrLoading);
Vue.component("FormInput", FormInput);
Vue.component("Button", Button);
Vue.use(vmodal);
Vue.use(VueHead);
Vue.use(debounce);
Vue.use(isEmpty);
Vue.use(VueCookies);
Vue.use(VueFormulate, {
    plugins: [ es ],
    locale: 'es',
    locales: {
        es: {
            required({ name }) {
                return `Este campo es obligatorio`
            },
            confirm({ name }) {
                return `No coincide`
            }
        }
    }
});
Vue.use(VCalendar, {
    componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});
  

if(process.env.VUE_APP_GTM_ID) {
    Vue.use(VueGtm,
            {
                id: process.env.VUE_APP_GTM_ID, // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
                compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
                enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
                debug: false, // Whether or not display console logs debugs (optional)
                loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
                vueRouter: router, // Pass the router instance to automatically sync with router (optional)
                trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
            }
    );
}

Vue.config.productionTip = false
Vue.prototype.config = config;

if(process.env.VUE_APP_SENTRY) {
    Sentry.init({
        Vue,
        dsn: "https://e3ef5e2931479b66152b376699f27610@o1356082.ingest.us.sentry.io/4507338468753408",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        trackComponents: true,
        hooks: ['create', 'mount'],
        tracePropagationTargets: ['localhost', /^\//],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

export var vue_instance = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
